module.exports = __webpack_public_path__ + "img/543.e1ae3f01.png";